import { AsyncPaginate } from 'react-select-async-paginate'
import { useAxiosPrivate } from 'shared/hooks'
import { forwardRef } from 'react'

import { FormError } from 'shared/atoms'
import { Label } from 'shared/atoms'

import { cn } from 'utils/style'
import { selectClassNames } from '../Select/classNames'

export type OptionType = {
	value: number
	label: string
}

export const UserSelect = forwardRef(
	({ required, className, variant = 'default', ...props }: any, ref) => {
		const axiosPrivate = useAxiosPrivate()

		const loadOptions = async (search: string, _loadedOptions: any, additional: any) => {
			let filteredOptions: OptionType[]
			let hasMore = false
			let cursor = additional?.cursor ?? ''
			let response = null

			if (!search) {
				response = await axiosPrivate.get(`/accounts/${cursor ? `?cursor=${cursor}` : ''}`)

				filteredOptions = response?.data?.results?.map((user: any) => ({
					label: `${user.email}`,
					value: user.id
				}))

				hasMore = !!response?.data?.next
				cursor = response?.data?.next.split('cursor=')[1]
			} else {
				const searchLower = search.toLowerCase()
				response = await axiosPrivate.get(
					`/accounts/${searchLower ? `?search=${searchLower}` : ''}`
				)

				cursor = ''
				hasMore = false
			}

			filteredOptions = response?.data?.results?.map((user: any) => ({
				label: `${user.email}${user.name ? ` - ${user.name}` : ''} `,
				value: user.id
			}))

			return {
				options: filteredOptions,
				hasMore,
				additional: {
					cursor
				}
			}
		}

		return (
			<div
				className={cn(
					'flex flex-col text-xs',
					variant === 'default' ? 'min-w-[130px] gap-y-2.5' : 'min-w-0 gap-y-1.5',
					props.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
					className
				)}>
				<Label
					disabled={variant === 'default' && props.disabled}
					required={required}
					text={props.label}
				/>
				<AsyncPaginate
					loadOptions={loadOptions}
					onChange={props.onChange}
					{...props}
					refs={ref}
					name={props.name}
					classNames={selectClassNames[variant as keyof typeof selectClassNames]}
					isClearable={props.isClearable ?? true}
					isDisabled={props.disabled}
					components={{ IndicatorSeparator: () => null }}
				/>
				<FormError text={props.error?.message} />
			</div>
		)
	}
)
